/* eslint-disable max-len */
import React from 'react'

export default function Status({state}) {
    
    return (
        <div className={`rounded ${state?'bg-[#C5FFD5]':'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5 w-fit ml-[26px]`}>
            <img
                loading="lazy"
                decoding="async"
                src={state?"/images/successDot.svg":'/images/inactive-Dot.svg'}
                alt="icon"
            />
            <span className="text-f7 font-normal text-[#031624] pl-1">
                {state?'Active':'Inactive'}
            </span>
        </div>
    )
}
